<template>
    <transition appear name="fade-transition">
        <div :class="classList">
            <label v-if="label" class="edit__content__label v-label theme--light">
                {{ label }}
            </label>
            <app-wysiwyg
                ref="input"
                v-model="inputValue"
                v-test-id
                class="edit__content__input"
                :rules="validators"
                :label="label"
                :hint="hint"
                :description="description"
                :disabled="disabled"
                :loading="loading"
                :readonly="readonly"
                :autocomplete="autocomplete ? 'on' : 'off'"
                :error-messages="errorMessages"
                :hide-toolbar="hideToolbar"
                :inline="inline"
                @validate="$emit('validate', $event)"
            />
            <v-input ref="input-error" v-model="inputValue" :error-messages="errorMessages" :rules="validators" />
        </div>
    </transition>
</template>

<script>
import Edit from './Edit';

export default {
    name: 'EditContent',
    components: {
        AppWysiwyg: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppWysiwyg'
            )
    },
    extends: Edit,
    props: {
        hideToolbar: {
            type: Boolean,
            default: false
        },
        inline: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.edit__content {
    position: relative;
    min-width: 10rem;

    &--form {
        margin-bottom: 0;
    }

    &--label {
        padding: 0.5rem 0 0;
    }

    &--error {
        .app-wysiwyg {
            border-width: 2px;
            border-color: var(--v-error-base);
        }
    }

    &__label {
        transform-origin: left;
        transform: scale(0.75);
        position: absolute;
        top: 0;
        left: 0.6rem;
        z-index: 1;
        padding: 0 0.5rem;
        &:after {
            content: '';
            position: absolute;
            top: calc(50% - 1px);
            left: 0;
            height: 50%;
            width: 100%;
            background: var(--v-background-base);
            z-index: -1;
        }
    }
}
</style>
